import React from 'react';
import { Container, Header } from './styles';
import { CartItem } from './CartItem';
import { useCart } from '~/context/OrderingSystem/Cart';

export const Cart = ({ is_drive_thru = false }) => {
  const { cart } = useCart();

  return (
    <Container>
      <Header>
        <h3>Carrinho</h3>
        <h3 style={{fontSize: 20}}>{is_drive_thru ? 'Drive-Thru' : 'Balcão'}</h3>
      </Header>
      {cart?.length > 0 ? (
        cart?.map((item) => {
          return <CartItem key={item.basket_id} item={item} />;
        })
      ) : (
        <span>Carrinho vazio :(</span>
      )}
    </Container>
  );
};
